import { useEffect, useState } from "react";
import PropTypes from "prop-types";

const ClientOnly = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return <>{children}</>;
};

ClientOnly.propTypes = {
  children: PropTypes.node.isRequired
};

export default ClientOnly;
